module.exports = __webpack_public_path__ + "assets/img/KeyReport_003.c7e5ad38-ps.jpg";